import React from "react";
import ComingSoon from "../Common/ComingSoon.jsx";

const HowToApplyPage = () => <ComingSoon />;

export default HowToApplyPage;

